import Line from "../../../../../src/entities/Line/Line";
import { rootEventBus, EnumRootEventBus } from "../../../../../src/managers/RootEventBus";
import { Coord } from "../../../../../src/types/Interface";


export default class LineManager {
	lines = [new Line(), new Line({ color: 0xb06efe })]
	constructor(
		private cCoord: Coord
	) {
		rootEventBus.on(EnumRootEventBus.startedCircleAnim, () => this.clearAll());
	}
	clearAll = () => this.lines.forEach(l => l.clear());
	draw(points: Coord[], tangentPointCoords: Coord[]) {
		this.lines[0].draw(this.cCoord, points[0]);
		this.lines[1].draw(tangentPointCoords[0], tangentPointCoords[1]);
	}
}